// hooks/useTranslateText.js
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { API_URL, LanguageContext } from "../utils";

const useTranslateText = (text) => {
  const { language } = useContext(LanguageContext);
  const [translated, setTranslated] = useState(text);

  useEffect(() => {
    const translate = async () => {
      if (language === "en") {
        setTranslated(text);
        return;
      }

      // try {
      //   const response = await axios.post(`${API_URL}/website/language-translate`, {
      //     text,
      //     target_lang: language,
      //   });
      //   setTranslated(response.data.text);
      // } catch (error) {
      //   console.error("Translation error:", error);
      //   setTranslated(text);
      // }
    };

    translate();
  }, [language, text]);

  return translated;
};

export default useTranslateText;

